import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,reorderArray } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import {Storage} from "@ionic/storage";
import { AddsceltaPage } from '../addscelta/addscelta';
import { EditsceltaPage } from '../editscelta/editscelta';
import { EditmenusceltaPage } from '../editmenuscelta/editmenuscelta';
import { SERVER_URL } from "../../config";

/**
 * Generated class for the SceltePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-scelte',
  templateUrl: 'scelte.html',
})
export class SceltePage {
  scelte: string[];
  errorMessage: string;
  menuscelta;
  link;
  constructor(public navCtrl: NavController, public navParams: NavParams,
               public rest: RestApiProvider,
               private readonly storage: Storage,

  ) {
    this.menuscelta=navParams.get('menuscelta');
    this.link = SERVER_URL + "/manifesti/files/"

  }
  getScelte() {
    console.log('menuscelta :'+this.menuscelta);

    this.rest.getScelte(this.menuscelta)
       .subscribe(
        scelte => this.scelte = scelte,
         error =>  this.errorMessage = <any>error);
      
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SceltePage');
    this.getScelte();
    
    console.log('scelte:'+this.scelte);

  }
  reorderItems(indexes){
    console.log("reorderItems:" + JSON.stringify(indexes));

    this.scelte = reorderArray(this.scelte, indexes);


    console.log("reorderItems list:" + JSON.stringify(this.scelte));
    var i = 0;
    this.scelte.forEach(function (element) {

      console.log(element["nome"]);
      element["visibilita"] = i;
      i++;
    });
    console.log("reorderItems list durante:" + JSON.stringify(this.scelte));



    this.rest.aggiornaListScelte(this.scelte);

}
openAddsceltaPage() {

  this.navCtrl.push(AddsceltaPage,{menuscelta:this.menuscelta});

}
openEditsceltaPage(scelta) {

  this.navCtrl.push(EditsceltaPage,{scelta:scelta});
 

}
openEditmenusceltePage(){
  this.navCtrl.push(EditmenusceltaPage, { menuscelta: this.menuscelta });

}


}



// WEBPACK FOOTER //
// ./src/pages/scelte/scelte.ts